<template>
  <header>
    <div class="mainTop">
      <h1>
        <span @click="reload()" class="mainlogo"><main-logo /></span>
      </h1>

      <!-- 내비 -->
      <div class="sub_top_nav">
        <sub-head-nav :pos_top="60"/>
      </div>
      <!-- 내비 -->

    </div>
  </header>
  <the-nav></the-nav>
</template>
<script>
import TheNav from '@/components/site/sub/TheNavigation.vue';
import SubHeadNav from '@/components/nav/SubHeadNav.vue';
export default {
  components:{
    SubHeadNav,
    TheNav,

  },
  computed:{
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$flashMessage.show({
        type: "info",
        title: '로그아웃되었습니다',
        message: '',
        });
        //this.$router.replace('/');
        window.location.reload();
    },
    reload(){
      this.$router.replace('/');
      //window.location.reload();
    }   
    
  }
}
</script>
<style lang="scss" scoped>

header {
  width: 100%;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  position:relative;
  z-index:10000;
  h1 {
    margin: 0;
    .mainlogo{cursor:pointer;}
  }
  ul
  {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
  }
  li
  {
      margin: 0 0.5rem;
  }
  .mainTop {
    width: 70%;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

  }
}
</style>
<style lang="scss">

.sub_top_nav{
  flex:1 1 auto;
  padding-left:10px;
  font-family:Malgun gothic;
  font-size: 15px;

  .mainNav{
   width: 600px;    
  }
  ul
  {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
  }

  li
  {
    margin: 0 0.5rem;
    span {
      text-decoration: none;
      font-weight:700;
      display: inline-block;
      border: 1px solid transparent;
    }
    span:active,
    span:hover,
    span.active
    {
      color:red;
    }
  }
 
}
</style>
